
import * as api from '../../requests/loader';

class Api {

    // TASK playerGetMedia(groupId = "", contentId = "", isTrailer = false, streamType = "", startTime = "", endTime = "" ) {
        //               (groupId = "", contentId = "", isTrailer = false, streamType = "", startTime = "", endTime = "" ) {
  static async getMedia(groupId, content_id, is_trailer, sType, startTime = null, endTime = null, payway_token = null, extraParamsEmitter = null) {      
    return await api.playerGetMedia(groupId, content_id, is_trailer, sType, startTime, endTime, payway_token, null, extraParamsEmitter);
    }

    static async getContentData(groupId) {
        return await api.contentData(groupId);
    }

    static async getContentRating(contenteData) {
        return await api.contentRating(contenteData);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/Api.js